import React from "react";
import Icon from "../Icon/Icon";
import s from "./Segmented.module.scss";

/**
 * Selettore a linguette (come Attive/Storico e Lista/Tabella di
 * gestionale-gls): stessa forma ovunque, così due selettori vicini si
 * leggono come comandi della stessa famiglia.
 */
export default function Segmented({ options, value, onChange, size = "md", className = "" }) {
  return (
    <div className={`${s.group} ${s[size] || ""} ${className}`} role="tablist">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={value === o.value}
          className={`${s.tab} ${value === o.value ? s.active : ""}`}
          onClick={() => onChange(o.value)}
          title={o.title}
        >
          {o.icon && <Icon name={o.icon} size={17} />}
          {o.label}
          {o.count !== undefined && o.count !== null && <span className={s.count}>{o.count}</span>}
        </button>
      ))}
    </div>
  );
}
